import React from 'react';
import { IoDocumentTextOutline, IoGlobeOutline, IoBusinessOutline, IoOpenOutline } from 'react-icons/io5';
import { CText } from '../../../components/common';
import { Source } from '../../../api/chat';

interface SourceCardProps {
  source: Source;
  colors: any;
}

const SourceCard: React.FC<SourceCardProps> = ({ source, colors }) => {
  const getIcon = () => {
    switch (source.type) {
      case 'web':
        return IoGlobeOutline;
      case 'insight':
      case 'company_insight':
        return IoBusinessOutline;
      case 'database':
      default:
        return IoDocumentTextOutline;
    }
  };

  const getTypeLabel = () => {
    if (source.report_type) {
      if (source.report_type.includes('concall')) return 'Concall';
      if (source.report_type.includes('annual')) return 'Annual Report';
    }
    switch (source.type) {
      case 'web':
        return 'Web';
      case 'insight':
      case 'company_insight':
        return 'Insight';
      case 'database':
      default:
        return 'Document';
    }
  };

  const Icon = getIcon();

  const handleClick = () => {
    if (source.url) {
      window.open(source.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className={`
        flex items-center gap-2 px-3 py-2 rounded-lg
        transition-colors cursor-pointer hover:opacity-80
      `}
      style={{
        backgroundColor: colors.inputBackground,
        border: `1px solid ${colors.borderColor}`,
      }}
      onClick={handleClick}
      title={source.title}
    >
      {/* Icon */}
      <div
        className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: colors.primary + '20' }}
      >
        {React.createElement(Icon as any, { size: 14, color: colors.primary })}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <CText
          type="r12"
          color={colors.textColor}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: 150,
            display: 'block',
          }}
        >
          {source.title || source.company || 'Source'}
        </CText>
        <div className="flex items-center gap-2">
          <CText type="r10" color={colors.grayScale400}>
            {getTypeLabel()}
          </CText>
          {source.similarity !== undefined && (
            <CText type="r10" color={colors.grayScale500}>
              {Math.round(source.similarity * 100)}% match
            </CText>
          )}
        </div>
      </div>

      {/* Open icon */}
      {source.url && (
        <div className="flex-shrink-0">
          {React.createElement(IoOpenOutline as any, { size: 12, color: colors.grayScale400 })}
        </div>
      )}
    </div>
  );
};

export default SourceCard;
